<template>
  <ul>
    <li v-for="option in options">
      <label @click="check(option.code)">
        <input type="radio" :name="name" :value="option.code" :checked="selected === option.code">
        <span class="radio-button"></span>
        <span>{{ option.label }}</span>
      </label>
    </li>
  </ul>
</template>

<script>
  import { isObject } from 'lodash'

  export default {
    data: () => ({
      selected: false
    }),
    props: {
      toggleChecked: {
        type: Function,
        required: true
      },
      checkedDefault: {
        type: [String, Object],
        required: false
      },
      options: {
        type: Array,
        required: true
      },
      name: {
        type: String,
        required: true
      }
    },
    mounted () {
      let code = null
      if (isObject(this.checkedDefault)) {
        code = this.checkedDefault.code
      } else {
        code = this.checkedDefault
      }

      if (code !== null) {
        this.check(code)
      }
    },
    methods: {
      check (code) {
        this.selected = code
        this.toggleChecked(this.name, code)
      }
    }
  }
</script>

<style lang="sass" scoped>
  ul
    list-style: none

  .radio-button
    position: relative
    width: 16px
    height: 16px
    border: 1px solid #DFE3E9
    display: inline-block
    vertical-align: middle
    cursor: pointer
    border-radius: 100%

  input[type='radio']
    display: none

    &:checked + .radio-button::before
      content: ''
      width: 8px
      height: 8px
      background: #7872ff
      display: inline-block
      position: absolute
      top: 3px
      left: 3px
      border-radius: 100%
</style>



// WEBPACK FOOTER //
// RadioButton.vue?004cf705